import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { DirhamIconColored } from '../DirhamIcon';
import { Toggle } from './CategoryModal';

const ServiceModal = ({
  language,
  isAdmin,
  editingItem,
  form,
  setForm,
  categories,
  saving,
  onSave,
  onClose,
}) => (
  <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto">
    <div className="bg-card border border-white/10 rounded-2xl p-6 max-w-lg w-full my-8">
      <h3 className="text-xl font-bold text-white mb-4">
        {editingItem
          ? language === 'ar' ? 'تعديل الخدمة' : 'Edit Service'
          : language === 'ar' ? 'إضافة خدمة جديدة' : 'Add New Service'}
      </h3>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-1">
            {language === 'ar' ? 'القسم' : 'Category'} *
          </label>
          <select
            value={form.category_id}
            onChange={(e) => setForm({ ...form, category_id: e.target.value })}
            className="w-full bg-zinc-800/50 border border-white/10 rounded-lg px-4 py-2 text-white"
          >
            <option value="">{language === 'ar' ? 'اختر القسم' : 'Select category'}</option>
            {categories.filter((c) => c.is_active).map((cat) => (
              <option key={cat.id} value={cat.id}>
                {language === 'ar' ? cat.name_ar : cat.name_en}
              </option>
            ))}
          </select>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              {language === 'ar' ? 'الاسم بالعربية' : 'Name (Arabic)'} *
            </label>
            <input
              type="text"
              value={form.name_ar}
              onChange={(e) => setForm({ ...form, name_ar: e.target.value })}
              className="w-full bg-zinc-800/50 border border-white/10 rounded-lg px-4 py-2 text-white"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              {language === 'ar' ? 'الاسم بالإنجليزية' : 'Name (English)'} *
            </label>
            <input
              type="text"
              value={form.name_en}
              onChange={(e) => setForm({ ...form, name_en: e.target.value })}
              className="w-full bg-zinc-800/50 border border-white/10 rounded-lg px-4 py-2 text-white"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              {language === 'ar' ? 'الوصف بالعربية' : 'Description (Arabic)'}
            </label>
            <textarea
              value={form.description_ar}
              onChange={(e) => setForm({ ...form, description_ar: e.target.value })}
              className="w-full bg-zinc-800/50 border border-white/10 rounded-lg px-4 py-2 text-white resize-none"
              rows={2}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              {language === 'ar' ? 'الوصف بالإنجليزية' : 'Description (English)'}
            </label>
            <textarea
              value={form.description_en}
              onChange={(e) => setForm({ ...form, description_en: e.target.value })}
              className="w-full bg-zinc-800/50 border border-white/10 rounded-lg px-4 py-2 text-white resize-none"
              rows={2}
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              {language === 'ar' ? 'السعر' : 'Price'}{' '}
              <DirhamIconColored className="w-3 h-3 inline" color="white" /> *
            </label>
            <input
              type="number"
              value={form.price}
              onChange={(e) => setForm({ ...form, price: e.target.value })}
              className="w-full bg-zinc-800/50 border border-white/10 rounded-lg px-4 py-2 text-white"
              min="0"
              step="0.01"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              {language === 'ar' ? 'المدة (دقيقة)' : 'Duration (min)'}
            </label>
            <input
              type="number"
              value={form.duration_minutes}
              onChange={(e) => setForm({ ...form, duration_minutes: parseInt(e.target.value) || 30 })}
              className="w-full bg-zinc-800/50 border border-white/10 rounded-lg px-4 py-2 text-white"
              min="5"
              step="5"
            />
          </div>
        </div>

        {isAdmin && (
          <div className="border-t border-white/10 pt-4 mt-4 space-y-3">
            <p className="text-sm font-medium text-muted-foreground mb-2">
              {language === 'ar' ? 'إعدادات الظهور' : 'Visibility Settings'}
            </p>
            <div className="flex items-center justify-between">
              <label className="text-sm text-foreground">
                {language === 'ar' ? 'إظهار للزوار' : 'Visible to visitors'}
              </label>
              <Toggle
                value={form.is_visible}
                onChange={() => setForm({ ...form, is_visible: !form.is_visible })}
              />
            </div>
            <div className="flex items-center justify-between">
              <label className="text-sm text-foreground">
                {language === 'ar' ? 'إظهار السعر' : 'Show price'}
              </label>
              <Toggle
                value={form.show_price}
                onChange={() => setForm({ ...form, show_price: !form.show_price })}
              />
            </div>
          </div>
        )}
      </div>

      <div className="flex gap-3 mt-6">
        <Button onClick={onSave} className="flex-1 bg-primary" disabled={saving}>
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : language === 'ar' ? 'حفظ' : 'Save'}
        </Button>
        <Button onClick={onClose} variant="outline" className="flex-1">
          {language === 'ar' ? 'إلغاء' : 'Cancel'}
        </Button>
      </div>
    </div>
  </div>
);

export default ServiceModal;
